export enum StoreMessageTypes {
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
}
